<script lang="ts">
    import { putDBEntry } from "../../../api"
    import Modal from "../../components/Modal.svelte"
    import Cta from "../../components/CTA.svelte"
    import hash from "object-hash"
    import { actionApproval, isMobile, newNotification } from "../../store"
    import MainModalLowerLine from "./MainModalLowerLine.svelte"
    import Calendar from "../../components/formComponents/Calendar.svelte"
    import Select from "../inputfields/Select.svelte"
    import { copyObject } from "../utils"

    import { createEventDispatcher } from "svelte"
    import Input from "../../components/formComponents/Input.svelte"
    import { onChange } from "../../components/formComponents/helper"
    export let task: TaskOilSpillRemoval | TaskTowing,
        showModal = false
    let originalTaskProtocolHash = "",
        originalObject = copyObject(task.manualProtocol)
    const dispatch = createEventDispatcher()
    $: if (!task?.manualProtocol) {
        task.manualProtocol = {
            entries: [],
        }
        originalTaskProtocolHash = hash(task.manualProtocol)
        originalObject = copyObject(task.manualProtocol)
    }
    $: if (!task?.manualProtocol?.entries?.length) {
        task.manualProtocol.entries = [
            {
                datetime: new Date(),
                eventId: "",
            },
        ]
        originalTaskProtocolHash = hash(task.manualProtocol)
        originalObject = copyObject(task.manualProtocol)
    }
    $: if (task?.manualProtocol && !originalTaskProtocolHash) {
        originalTaskProtocolHash = hash(task.manualProtocol)
        originalObject = copyObject(task.manualProtocol)
    }
    $: catchAccidentalExit = {
        active: true,
        originalHash: originalTaskProtocolHash,
        currentObject: task.manualProtocol,
        originalObject: originalObject,
    }
    let editMode = false
    let refresh = false
    // wenn das erste element einen wert hat in ereignis, füge eine neue zeile am anfang hinzu
    $: if (task.manualProtocol.entries[0].eventId) {
        task.manualProtocol.entries = [
            {
                datetime: new Date(),
                eventId: "",
            },
            ...task.manualProtocol.entries,
        ]
        refresh = !refresh
    }
</script>

{#if showModal}
    <Modal
        show="{showModal}"
        mainModal="{true}"
        showCloseIcon="{true}"
        size="xl"
        on:close="{() => {
            task.manualProtocol = copyObject(originalObject)
            originalTaskProtocolHash = hash(task.manualProtocol || {})
            editMode = false
            showModal = false
        }}"
        catchAccidentalExit="{catchAccidentalExit}"
    >
        <div
            slot="header"
            class="inner-modal-header"
        >
            <div class="upper">
                <div class="title">
                    <img
                        src="../../../assets/icons/solar_alarm-add-outline.svg"
                        alt="icon"
                    />
                    <p>Zeitstempel</p>
                </div>
            </div>
            <MainModalLowerLine task="{task}" />
        </div>
        <div class="main-wrapper">
            <ul class="wrapper form">
                {#key [editMode, refresh]}
                    {#each [...(task.manualProtocol?.entries || [])] as entry, i}
                        <li class:editMode="{editMode}">
                            <div>
                                <Calendar
                                    placeholder="Zeitstempel"
                                    id="timestamp-{i}"
                                    bind:dateValue="{entry.datetime}"
                                    editMode="{editMode || i == 0}"
                                    timestamp="{true}"
                                    greyMode="{i == 0}"
                                />
                            </div>
                            <div>
                                <Select
                                    editMode="{editMode || i == 0}"
                                    field="{{
                                        widget: 'select',
                                        options: {
                                            endpoint: 'option',
                                            params: {
                                                sort: 'name',
                                                filter: {
                                                    category: 'taskEvent',
                                                    'additionalInfos.taskTypes':
                                                        task.taskType == 'oilSpillRemoval' ? 'oilTrack' : 'towing',
                                                },
                                            },
                                            mapping: {
                                                id: 'id',
                                                name: 'name',
                                            },
                                        },
                                        name: 'eventId',
                                        label: 'Ereignis',
                                    }}"
                                    bind:value="{entry.eventId}"
                                />
                            </div>
                            {#if editMode}
                                <div class="trash">
                                    <Cta
                                        type="tableButton"
                                        icon="solar_trash-bin-trash-outline"
                                        on:click="{() => {
                                            $actionApproval = {
                                                modalTitle: 'Löschen',
                                                modalText: 'Möchten Sie diesen Zeitstempel wirklich löschen?',
                                                callback: () => {
                                                    task.manualProtocol.entries = task.manualProtocol.entries.filter(
                                                        (_, index) => index !== i
                                                    )
                                                    editMode = false
                                                },
                                            }
                                        }}"
                                    />
                                </div>
                            {/if}
                        </li>
                    {/each}
                {/key}
            </ul>
            <div class="form">
                <Input
                    type="textarea"
                    placeholder="Zusatzinformationen"
                    bind:value="{task.manualProtocol.additionalInformation}"
                    onChange="{onChange}"
                    id="additionalInformation"
                />
            </div>
        </div>
        <div
            class="inner-footer"
            slot="footer"
        >
            <div>
                {#if editMode}
                    <Cta
                        type="tertiaryButton"
                        icon="mage_plus"
                        content="{$isMobile ? 'Zeitstempel' : 'Zeitstempel hinzufügen'}"
                        on:click="{(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            editMode = false
                            if (!task.manualProtocol)
                                task.manualProtocol = {
                                    entries: [],
                                }
                            task.manualProtocol.entries = [
                                {
                                    datetime: new Date(),
                                    eventId: '',
                                },
                                ...(task.manualProtocol?.entries || []),
                            ]
                        }}"
                    />
                {:else}
                    <Cta
                        type="tertiaryButton"
                        icon="solar_pen-outline"
                        content="{$isMobile ? 'Zeitstempel' : 'Zeitstempel bearbeiten'}"
                        on:click="{(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            editMode = true
                        }}"
                    />
                {/if}
            </div>
            <div>
                <Cta
                    type="primaryButton"
                    icon="solar_diskette-outline"
                    content="Speichern"
                    disabled="{originalTaskProtocolHash === hash(task.manualProtocol || {})}"
                    on:click="{(e) => {
                        e.stopPropagation()
                        e.preventDefault()

                        // @ts-ignore
                        putDBEntry('task', {
                            id: task.id,
                            manualProtocol: task.manualProtocol,
                        })
                            .catch((error) => {
                                console.error('Error updating task', error)
                            })
                            .finally(() => {
                                dispatch('updateTaskProtocol', task.manualProtocol)
                                setTimeout(() => {
                                    originalTaskProtocolHash = hash(task.manualProtocol || {})
                                    originalObject = copyObject(task.manualProtocol)
                                    editMode = false
                                    newNotification({
                                        html: 'Zeitstempel aktuallisiert',
                                        class: 'success',
                                    })
                                }, 100)
                            })
                    }}"
                />
            </div>
        </div>
    </Modal>
{/if}

<style lang="less">
    @import "../../../../assets/variables.less";
    .inner-modal-header {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        max-width: 100%;
        gap: 1.2rem;
        color: var(--white-100);
        .upper {
            display: flex;
            width: 100%;
            justify-content: space-between;
            .title {
                display: flex;
                gap: 0.6rem;
                align-items: center;
                p {
                    font-size: 1.2rem;
                }
            }
            align-items: center;
        }
    }
    .main-wrapper {
        min-height: 300px;
        .wrapper {
            display: flex;
            gap: 0.6rem;
            flex-direction: column;

            padding: 1.2rem 0px;
            li {
                display: grid;
                align-items: center;
                justify-items: center;
                gap: 0.6rem;
                padding: 0.6rem;
                border: 1px solid var(--grey-300);
                border-radius: 12px;
                grid-template-columns: 1fr 1fr;
                @media @mobile {
                    display: flex;
                    flex-direction: column;
                }
                div {
                    width: 100%;
                    height: 100%;
                }
                &.editMode {
                    grid-template-columns: 6fr 5fr 1fr;
                    .trash {
                        width: 1.6rem;
                        height: 1.6rem;
                    }
                    @media @mobile {
                        display: grid;
                        grid-template-columns: 5fr 1fr !important;
                        > :nth-child(1) {
                            grid-column: 1 / 2 !important;
                            grid-row: 1 / 2 !important;
                        }

                        > :nth-child(2) {
                            grid-column: 1 / 2 !important;
                            grid-row: 2 / 3 !important;
                        }

                        > :nth-child(3) {
                            grid-column: 2 / 3 !important;
                            grid-row: 1 / 3 !important;
                            display: flex;
                            height: 100%;
                            align-items: center;
                        }
                    }
                }
            }
        }
    }
    .inner-footer {
        display: flex;
        width: 100%;
        justify-content: space-between;
        background-color: var(--grey-300);
        padding: 0.6rem 0rem;
        div {
            display: flex;
            gap: 0.6rem;
        }
    }
</style>
